import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableColumn } from 'src/app/components/common/common-table/common-table.component';
import { WorkflowService } from 'src/app/services/workflow.service';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { TemplateWorkflowSearchRequest, WorkflowType } from 'src/app/models';
import { UseTemplateActionsComponent } from './use-template-actions/use-template-actions.component';
import { WorkflowJanusService } from '../workflow-janus.service';

@Component({
  selector: 'app-use-template-workflow',
  templateUrl: './use-template-workflow.component.html',
  styleUrls: ['./use-template-workflow.component.scss'],
  standalone: false
})
export class UseTemplateWorkflowComponent implements OnInit {

  isEditorVisible: boolean = false;
  isOverlayOpen = true;
  columns: TableColumn[] = [];
  tableData: any[] = [];
  isLoading = true;
  name: string = '';
  tags: string = '';
  handleAction: (value: any) => void;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private workflowService: WorkflowService,
    private workflowJanusService: WorkflowJanusService
  ) { }

  loadTemplates() {
    this.isLoading = true;

    const request = {
      name: '',   // empty → fetch all
      tags: []    // empty → fetch all
    };

    this.workflowService
      .searchTemplateLibraryWorkflows(request, false)
      .subscribe({
        next: (response: any) => {
          this.tableData = response.items.map(item => ({
            raw: item,
            name: item.name || '',
            description: item.description || '',
            tags: Array.isArray(item.tags)
              ? item.tags.join(', ')
              : ''
          }));

          this.isLoading = false;
        },
        error: (err) => {
          console.error('Load API error:', err);
          this.isLoading = false;
        }
      });
  }

  search() {
    this.isLoading = true;

    const tagInput = this.tags?.toLowerCase().trim();

    const tagList = this.tags
      ?.split(',')
      .map(t => t.trim())
      .filter(t => t);

    const request = new TemplateWorkflowSearchRequest({
      name: this.name,
      tags: tagList   // keep as is (for exact match if full tag entered)
    });

    this.workflowService
      .searchTemplateLibraryWorkflows(request, false)
      .subscribe({
        next: (response: any) => {

          let items = response.items;

          // 🔥 ADD THIS BLOCK (partial tag match)
          if (tagInput && items?.length) {
            items = items.filter(item =>
              (item.workflowTags || item.tags || []).some(tag =>
                tag.toLowerCase().includes(tagInput)
              )
            );
          }

          this.tableData = items.map(item => ({
            raw: item,
            name: item.version?.name || item.name || '',
            description: item.version?.description || item.description || '',
            tags: Array.isArray(item.workflowTags)
              ? item.workflowTags.join(', ')
              : Array.isArray(item.tags)
                ? item.tags.join(', ')
                : ''
          }));

          this.isLoading = false;
        },
        error: (err) => {
          console.error('Search API error:', err);
          this.isLoading = false;
        }
      });
  }

  ngOnInit() {
    this.isEditorVisible = true;
    this.setupColumns();
    this.loadTemplates();
  }

  setupColumns(): void {
    this.columns = [
      {
        key: 'name',
        label: 'Name',
        headerType: 'text',
        cellType: 'text',
        hideMenu: false,
        hideable: true,
      },
      {
        key: 'description',
        label: 'Description',
        headerType: 'text',
        cellType: 'text',
        hideMenu: false,
        hideable: true,
      },
      {
        key: 'tags',
        label: 'Tags',
        headerType: 'text',
        cellType: 'text',
        hideMenu: false,
        hideable: true,
      },
      {
        key: 'actions',
        label: 'Actions',
        headerType: 'text',
        hideMenu: false,
        hideable: true,
        cellType: 'component',
        component: UseTemplateActionsComponent,
        componentInputs: (row) => ({
          row: row.raw,
          isEntitledToViewWorkflow: this.canViewWorkflow(row.raw),
          isEntitledToImportWorkflow: this.canImportWorkflow(row.raw)
        }),
        componentOutputs: {
          action: this.handleAction
        }
      }
    ];
  }
  canImportWorkflow(raw: any) {
    return true;
  }
  canViewWorkflow(raw: any) {
    return true;
  }

  close() {
    this.isEditorVisible = false;
    this.workflowJanusService.setNewWorkflowButtonDisabled(false);
    this.router.navigate([{ outlets: { modal: null } }],
      { relativeTo: this.route.parent }
    );
  }

}
